<template>
	<div class="pr-move-area">
		<div class="btn-area">
			<a href="/uiux" class="btn-back">Back to List</a>
		</div>
		<div class="item-wrap">
			<div class="item prev">
				<router-link :to="prevUrl">
					<span
						class="bg-rotate"
						:style="{ backgroundImage: 'url(' + prevBg + ')' }"
					></span>
					<dl>
						<dt>Previous</dt>
						<dd>{{ prevText }}</dd>
					</dl>
				</router-link>
			</div>
			<div class="item next">
				<router-link
					:to="nextUrl"
					:style="{ backgroundImage: 'url(' + nextBg + ')' }"
				>
					<dl>
						<dt>Next</dt>
						<dd>{{ nextText }}</dd>
					</dl>
				</router-link>
			</div>
		</div>
	</div>
</template>
<script>
import { store } from "../data/store.js";
export default {
	data() {
		return {
			store,
			noneHref: null,
			currentRoute: window.location.pathname,
			prevUrl: "javascript:;",
			nextUrl: "javascript:;",
			prevBg: "",
			nextBg: "",
			prevText: "Coming Soon",
			nextText: "다음 글이 없습니다.",
		};
	},
	mounted: function () {
		var pjUrl = this.$route.path.split("/");
		var pjNameVal = pjUrl[pjUrl.length - 1];
		var allContent = store.projects;
		var invalidEntries = 0;

		function filterByID(item) {
			if ("prjUrl" in item) {
				return true;
			}
			invalidEntries++;
			return false;
		}

		var allContentJson = allContent.filter(filterByID);
		var pjIdx = allContentJson.findIndex((x) => x.prjUrl === pjNameVal);
		var pjLength = allContentJson.length;

		//prev
		if (pjIdx - 1 >= "0") {
			this.prevUrl = "/uiux/" + allContentJson[pjIdx - 1].prjUrl;
			this.prevBg = allContentJson[pjIdx - 1].thumbsrc;
			this.prevText = allContentJson[pjIdx - 1].prjtitle;
		}

		//next
		if (pjIdx < pjLength - 1) {
			this.nextUrl = "/uiux/" + allContentJson[pjIdx + 1].prjUrl;
			this.nextBg = allContentJson[pjIdx + 1].thumbsrc;
			this.nextText = allContentJson[pjIdx + 1].prjtitle;
		}
	},
};
</script>

<style scoped>
.bg-rotate {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 0;
	background-size: cover;
	background-position: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/pjMove.vue